module.exports = __webpack_public_path__ + "static/img/tab-banner1.01f5b1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/4/tab-banner1.png
// module id = XQ6O
// module chunks = 1